import ColorSwatchButton from '@/components/ColorButton/ColorSwatchButton'
import ColorPickerButton from '@/components/ColorButton/ColorPickerButton'
import type { ColorPickerPopoverPlacement } from '@/components/ColorButton/ColorPickerButton'

export type { ColorPickerPopoverPlacement }

export interface ColorPaletteGridProps {
  /** Flat list `string[]` renders as a single wrapping row.
   *  Nested `string[][]` renders each inner array as its own row. */
  colors: string[] | string[][]
  selectedColor: string | null
  onChange: (color: string, isFinal: boolean) => void
  showPickerButton?: boolean
  pickerConfig?: {
    placement?: ColorPickerPopoverPlacement
    offset?: { x?: number; y?: number }
  }
  isSecondaryStyle?: boolean
}

function isNestedArray(c: string[] | string[][]): c is string[][] {
  return c.length > 0 && Array.isArray(c[0])
}

function ColorPaletteGrid({
  colors,
  selectedColor,
  onChange,
  showPickerButton = false,
  pickerConfig,
  isSecondaryStyle,
}: ColorPaletteGridProps) {
  const rows: string[][] = isNestedArray(colors) ? colors : [colors]

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', width: '100%' }}>
      {rows.map((row, rowIndex) => (
        <div key={rowIndex} style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
          {row.map((color, colIndex) => (
            <ColorSwatchButton
              key={`${color}-${colIndex}`}
              color={color}
              isActive={selectedColor === color}
              onClick={c => onChange(c, true)}
              isSecondaryStyle={isSecondaryStyle}
            />
          ))}
          {showPickerButton && rowIndex === rows.length - 1 && (
            <ColorPickerButton
              colorSelected={selectedColor && selectedColor !== 'transparent' ? selectedColor : '#000000'}
              onChange={onChange}
              isSecondaryStyle={isSecondaryStyle}
              popoverPlacement={pickerConfig?.placement}
              popoverOffset={pickerConfig?.offset}
            />
          )}
        </div>
      ))}
    </div>
  )
}

export default ColorPaletteGrid
